import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "d-flex justify-content-between bd-highlight mb-3" }
const _hoisted_3 = {
  class: "input-group align-self-center ms-auto p-2 bd-highlight",
  style: {"width":"25%"}
}
const _hoisted_4 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "序号"),
    /*#__PURE__*/_createElementVNode("th", null, "客户"),
    /*#__PURE__*/_createElementVNode("th", null, "房号"),
    /*#__PURE__*/_createElementVNode("th", null, "类型"),
    /*#__PURE__*/_createElementVNode("th", null, "数值"),
    /*#__PURE__*/_createElementVNode("th", null, "颜色"),
    /*#__PURE__*/_createElementVNode("th", null, "形状"),
    /*#__PURE__*/_createElementVNode("th", null, "录入人"),
    /*#__PURE__*/_createElementVNode("th", null, "操作日期"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1)
const _hoisted_6 = { id: "member-list" }
const _hoisted_7 = { class: "flex-row flex-align-center" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "article-keywords",
            class: "form-control",
            placeholder: "客户ID",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keywords) = $event))
          }, null, 512), [
            [_vModelText, _ctx.keywords]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.loadRecordList(1)))
          }, "搜索")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataList, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(value.customer), 1),
                _createElementVNode("td", null, _toDisplayString(value.roomNo), 1),
                _createElementVNode("td", null, _toDisplayString(value.type) + "(" + _toDisplayString(value.subtype) + ")", 1),
                _createElementVNode("td", null, _toDisplayString(value.value) + _toDisplayString(value.unit||""), 1),
                _createElementVNode("td", null, _toDisplayString(value.color), 1),
                _createElementVNode("td", null, _toDisplayString(value.shape), 1),
                _createElementVNode("td", null, _toDisplayString(value.operatorName), 1),
                _createElementVNode("td", null, _toDisplayString(value.operateDate) + " " + _toDisplayString(value.clockTime), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_trash.png",
                      onClick: ($event: any) => ($setup.deleteRecord(value.id, value.type))
                    }, null, 8, _hoisted_8)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_Pagination, {
          page: $setup.nowPage,
          max: $setup.totalPage/50,
          onLoadPage: $setup.loadRecordList
        }, null, 8, ["page", "max", "onLoadPage"])
      ])
    ]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}